import { hasStaticPermission } from "@repo/db"
import { createFileRoute, redirect } from "@tanstack/react-router"

const staticRoles = new Set(["owner", "admin", "manager", "member"])

export const Route = createFileRoute("/$dealership/settings")({
  beforeLoad: async ({ context, params }) => {
    const ctx = context as { user?: { dealership?: { role?: string } }; isSuperAdmin?: boolean }
    const role = ctx?.user?.dealership?.role
    const isSuperAdmin = ctx?.isSuperAdmin ?? false
    const isStaticRole = !!role && staticRoles.has(role)

    if (
      !isSuperAdmin &&
      (!role || (isStaticRole && !hasStaticPermission(role, "settings", "view")))
    ) {
      throw redirect({ to: "/$dealership/dashboard", params: { dealership: params.dealership } })
    }
  },
})
